/* oxlint-disable react/no-unstable-nested-components -- LINTER migration follow up */
import { Toaster } from "@grafit/design-system/components/molecules/toast";
import { EnvironmentRibbon } from "@grafit/design-system/components/organisms/environment-ribbon";
import { ErrorBoundary } from "@grafit/shared/observability/sentry-front";
import React from "react";
import { useFeatureFlag } from "../utils/feature-flags";
import { GlobalStatusBanner } from "./global-status-banner";
import { RootErrorFallbackWithAuth } from "./root-error-fallback";
import { Outlet } from "./router-api";

export function RootComponent() {
  const isTanstackDevtoolsEnabled = useFeatureFlag("tanstack-devtools");

  return (
    <ErrorBoundary fallback={({ error }) => <RootErrorFallbackWithAuth error={error} />} handled={false}>
      <GlobalStatusBanner />
      <Outlet />
      <EnvironmentRibbon />

      <Toaster />

      {import.meta.env.DEV && isTanstackDevtoolsEnabled && <TanStackDevtoolsLazy />}
    </ErrorBoundary>
  );
}

const TanStackDevtoolsLazy = React.lazy(async () => {
  const [{ TanStackDevtools }, { TanStackRouterDevtoolsPanel }, { ReactQueryDevtoolsPanel }] = await Promise.all([
    import("@tanstack/react-devtools"),
    import("@tanstack/react-router-devtools"),
    import("@tanstack/react-query-devtools"),
  ]);

  return {
    default: () => (
      <TanStackDevtools
        config={{ openHotkey: [] }}
        plugins={[
          { name: "TanStack Query", render: <ReactQueryDevtoolsPanel /> },
          { name: "TanStack Router", render: <TanStackRouterDevtoolsPanel /> },
        ]}
      />
    ),
  };
});
